// client\src\pages\financeiro.jsx

import React from 'react'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import styles from '../App.module.css';
import { nomeVendedor, fonteLeads } from '../components/equipeagiliza';
import api from '../api/axios';
import { useState } from 'react';
import { useEffect } from 'react';
import CreateCliente from '../components/Usuarios/CreateCliente';
import { isAuthenticated } from '../index'
import { FaCamera } from "react-icons/fa";
import notifications from '../components/notifications';
import GraficoVenda from "../components/Graficos/GraficoVenda";

import { format } from 'date-fns';
import GraficoParceiros from '../components/Graficos/GraficoParceiro';

function Financeiro() {
    const [notificationType, setNotificationType] = useState(0);
    const { authenticated, userPermission, userStatus, userCpf } = isAuthenticated();

    // ------------------- ESTADOS -------------------
    const [servicos, setServicos] = useState([]);

    const [parceirosList, setParceirosList] = useState([]);
    const [rangeDateSells, setRangeDateSells] = useState(60);

    const [clienteId, setClienteId] = useState("");
    const [vendedor, setVendedor] = useState("");
    const [servicosJSON, setservicosJSON] = useState({});
    const [servicosJSONaux, setservicosJSONaux] = useState({});
    const [valorPago, setValorPago] = useState(0);
    const [obs, setObs] = useState("");
    const [fonteLead, setFonteLead] = useState("");

    const [statusFinanca, setStatusFinanca] = useState(0);
    const [dataFechamento, setDataFechamento] = useState(getCurrentDate());

    const [nomeCliente, setNomeCliente] = useState("");
    const [contatoCliente, setContatoCliente] = useState("");
    const [cpfCliente, setCpfCliente] = useState("");
    const [parceiroCliente, setParceiroCliente] = useState("");

    const [clienteIdComprovante, setClienteIdComprovante] = useState("");
    const [nomeClienteComprovante, setNomeClienteComprovante] = useState("");
    const [contatoClienteComprovante, setContatoClienteComprovante] = useState("");
    const [cpfClienteComprovante, setCpfClienteComprovante] = useState("");
    const [parceiroClienteComprovante, setParceiroClienteComprovante] = useState("");
    const [vendedorComprovante, setVendedorComprovante] = useState("");
    const [servicosComprovante, setServicosComprovante] = useState("");
    const [valorComprovante, setValorComprovante] = useState("");
    const [obsComprovante, setObsComprovante] = useState("");
    const [statusFinancaComprovante, setStatusFinancaComprovante] = useState("");
    const [dataFechamentoComprovante, setDataFechamentoComprovante] = useState("");
    const [comprovanteEnviado, setComprovanteEnviado] = useState(false);
    const [imgIdsComprovante, setImgIdsComprovante] = useState([]);
    const [fonteLeadComprovante, setFonteLeadComprovante] = useState("");

    const [vendedoresList, setVendedoresList] = useState([]);
    const [produtoresList, setProdutoresList] = useState([]);

    const [clientesList, setClientesList] = useState([]);
    const [financaList, setFinancaList] = useState([]);
    const [showAllClientes, setShowAllClientes] = useState(false);

    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [clienteDetails, setClienteDetails] = useState(null);

    const [editingSale, setEditingSale] = useState(null);
    const [botoesClicados, setBotoesClicados] = useState({});

    const [clienteError, setClienteError] = useState(false);


    // ------------------- EFFECTS -------------------
    useEffect(() => {
        if (notificationType && notifications[notificationType]) {
            notifications[notificationType]();
            setNotificationType(0);
        }
    }, [notificationType]);

    // Carrega lista de serviços e clientes
    useEffect(() => {
        getUsers();

        getVendedoresProdutores();
    }, []);

    // Puxa as finanças do vendedor logado
    useEffect(() => {
        if (authenticated && userCpf) {
            getFinancaVendedor(userCpf, rangeDateSells);
        }
    }, [authenticated, userCpf, rangeDateSells]);

    // Quando `servicos` atualiza, inicializa 'servicosJSONaux' com 0
    useEffect(() => {
        if (servicos.length > 0) {
          const valoresIniciais = {};
          for (let i = 1; i <= servicos.length; i++) {
            valoresIniciais[i] = 0;
          }
          setservicosJSONaux(valoresIniciais);
        }
      }, [servicos]);
      

    // ------------------- FUNÇÕES DE APOIO -------------------
    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    function obterJsonServicosPortugues(servicosContratados) {
        const descricoesServicos = servicosContratados.map(servico => {
            const servicoDetalhes = servicos.find(s => s.index === servico.index);
            if (servicoDetalhes) {
                return `(${servico.quantidade} un)${servicoDetalhes.nome},`;
            } else {
                return `Serviço não encontrado para o índice ${servico.index}`;
            }
        });
        return `\n \n${descricoesServicos.join('\n')}`;
    }

    // ------------------- CHAMADAS DE API -------------------
    async function getUsers() {
        try {
            const resParceiro = await api.get('/clientesParceiros');
            const resCliente = await api.get('/clientesAgiliza');
            setParceirosList(resParceiro.data);
            setClientesList(resCliente.data);
            console.log("resCliente.data")
            console.log(resCliente.data)
    
            // Puxa serviços
            const response = await api.get('/servicos');
            setServicos(response.data);
            
        } catch (error) {
            console.error('Erro ao carregar usuários:', error);
            NotificationManager.error('Erro ao carregar usuários.', 'Erro');
            
        }

    }

    async function getVendedoresProdutores() {
        try {
            const resVendedoresProdutores = await api.get('/vendedores-produtores');
            if (resVendedoresProdutores.data && Array.isArray(resVendedoresProdutores.data.data)) {
                const users = resVendedoresProdutores.data.data;
                setVendedoresList(users.filter(user => user.is_vendedor === 1));
                setProdutoresList(users.filter(user => user.is_produtor === 1));
            } else {
                NotificationManager.error('Erro ao carregar vendedores e produtores.', 'Erro');
            }
        } catch (error) {
            console.error('Erro ao carregar dados:', error);
            NotificationManager.error('Erro ao carregar dados.', 'Erro');
        }
    }

    async function getFinancaVendedor(vendedorId, maxDias) {
        if (!vendedorId) {
            console.log("vendedorId é inválido ou não fornecido");
            return;
        }
        try {
            const response = await api.get(`/FinancasVendedor/${vendedorId}?maxDias=${maxDias}`);
            setFinancaList(response.data);
            // console.log("response.data")
            // console.log(response.data)
            return response.data;
        } catch (error) {
            console.error("Error fetching client details", error);
        }
    }

    async function getClienteDetails(clienteID) {
        try {
            const response = await api.get(`/clienteAgiliza/${clienteID}`);
            setClienteDetails(response.data);
            setNomeClienteComprovante(response.data.Nome);
            setContatoClienteComprovante(response.data.contato);
            setCpfClienteComprovante(response.data.cpf);
            setParceiroCliente(response.data.parceiro);

            if (response.data.fonte === 1) {
                setFonteLeadComprovante(`Parceiro: @${parceirosList[response.data.parceiro].usuarioParceiro}`);
            } else if (response.data.fonte && response.data.fonte !== 1) {
                const fonteLeadSelecionado = fonteLeads.find(f => f.value === response.data.fonte);
                if (fonteLeadSelecionado) {
                    setFonteLeadComprovante(fonteLeadSelecionado.nome);
                } else {
                    console.error('Fonte não encontrada para o valor:', response.data.fonte);
                }
            }
        } catch (error) {
            console.error("Error fetching client details", error);
        }
    }

    // ------------------- FUNÇÕES DE FORMULÁRIO -------------------
    // ATUALIZA valor de um índice específico e já CALCULA o total no callback
    const atualizarValor = (indice, novoValor) => {
        novoValor = isNaN(parseFloat(novoValor)) ? 1 : novoValor;

        setservicosJSONaux(prevState => {
            // Copia o estado anterior e atualiza o índice
            const updatedState = { ...prevState, [indice]: novoValor };

            // Calcula o total considerando cada item e valor
            let total = 0;
            for (const item of servicos) {
                const quantidade = updatedState[item.index] || 0;
                const precoUnitario = parseFloat(item.value) || 0;
                total += quantidade * precoUnitario;
            }
            setValorPago(total);

            return updatedState;
        });
    };

    const handleButtonClick = (item) => {
        if (!botoesClicados[item.nome]) {
            // Se não estava clicado, clique e inicie com quantidade = 1
            setBotoesClicados(prevState => ({ ...prevState, [item.nome]: true }));
            atualizarValor(item.index, 1);
        } else {
            // Se já estava clicado, zera quantidade
            atualizarValor(item.index, 0);
            setBotoesClicados(prevState => ({ ...prevState, [item.nome]: false }));
        }
    };

    const handleAtualizarValor = (indice, novoValor) => {
        // Chamamos apenas atualizarValor, pois o total já é recalculado dentro dele.
        atualizarValor(indice, novoValor);
    };

    const obterJsonServicos = () => {
        const servicosArray = Object.entries(servicosJSONaux)
            .map(([index, quantidade]) => ({
                index: parseInt(index, 10),
                quantidade: parseInt(quantidade, 10)
            }))
            .filter(servico => servico.quantidade > 0);

        setservicosJSON(servicosArray);
        setServicosComprovante(obterJsonServicosPortugues(servicosArray));
        return servicosArray;
    };

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        if (selectedFiles.length + files.length <= 10) {
            setFiles([...files, ...selectedFiles]);
        } else {
            alert('Você pode selecionar no máximo 10 imagens.');
        }
    };

    const validateFormFinanca = () => {
        if (vendedor === "" || servicosJSONaux === "" || valorPago === "" || dataFechamento === "") {
            setNotificationType(3);
            return false;

        }
        if (clienteId === "" || clienteId === 0) {
            setClienteError(true);
            setNotificationType(20);
            return false;
        } else {
            console.log("cliente erro4")
            setClienteError(false);
        }



        return true;
    };

    const handleToggleShowAll = () => {
        setShowAllClientes(prevState => !prevState);
    };

    async function handleClienteCriado(novoCliente) {
        setClientesList(prevList => [...prevList, novoCliente]);
        handleClienteSelecionado(novoCliente.id);
        setClienteId(novoCliente.id);
    }

    const handleClienteSelecionado = (clienteId) => {
        setClienteId(clienteId);
    };

    // ------------------- UPLOAD DE IMAGENS -------------------
    const uploadImages = async () => {
        const formData = new FormData();
        files.forEach(file => {
            formData.append('images', file);
        });
        setUploading(true);
        try {
            const response = await api.post('/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.data.status) {
                setFiles([]);
                return response.data.insertIds;
            } else {
                console.log('Não foi feito UPLOAD de imagens.');
            }
        } catch (error) {
            console.error('Erro ao fazer upload das imagens:', error);
            setNotificationType(20);
        } finally {
            setUploading(false);
        }
    };

    // ------------------- ENVIO DE DADOS (NOTA) -------------------
    const insertDataFinanca = async () => {
        const servicosJSONN = JSON.stringify(obterJsonServicos());
        if (validateFormFinanca() === true) {
            const imageIdsAux = await uploadImages();

            const res = await api.post('/createFinanca', {
                clienteId,
                vendedor,
                servicosJSONN,
                valorPago,
                obs,
                statusFinanca,
                dataFechamento,
                imageIds: imageIdsAux
            });
            if (res.data.status === true) {
                setNotificationType(1);
                setComprovanteEnviado(true);
                getClienteDetails(clienteId);

                setNomeClienteComprovante(nomeCliente);
                setContatoClienteComprovante(contatoCliente);
                setCpfClienteComprovante(cpfCliente);
                setParceiroCliente(parceiroCliente);
                setClienteIdComprovante(clienteId);
                setVendedorComprovante(vendedor);
                setServicosComprovante(obterJsonServicosPortugues(obterJsonServicos()));
                setValorComprovante(valorPago);
                setObsComprovante(obs);
                setFonteLeadComprovante(fonteLead);
                setStatusFinancaComprovante(statusFinanca);
                setDataFechamentoComprovante(dataFechamento);

                clearDataFinanca();
            } else {
                setNotificationType(2);
            }
        } else {
            // setNotificationType(3);
        }
    };

    const clearDataFinanca = () => {
        setVendedor("");
        setservicosJSONaux("");
        setValorPago("");
        setObs("");
        setStatusFinanca(0);
        setDataFechamento(getCurrentDate());
        setFiles([]);
        setFonteLead("");
    };

    // ------------------- EDIÇÃO DE VENDA -------------------
    const handleEdit = (sale) => {
        setEditingSale(sale);
    };

    const handleSaveEdit = async () => {
        if (editingSale) {
            try {
                const servicosParsed = Array.isArray(editingSale.servicos)
                    ? editingSale.servicos
                    : JSON.parse(editingSale.servicos);

                const res = await api.post('/updateFinanca', {
                    id: editingSale.id,
                    clienteId: editingSale.clienteId,
                    vendedor: editingSale.vendedor,
                    servicosJSONN: servicosParsed,
                    valorPago: editingSale.valor,
                    obs: editingSale.obs,
                    statusFinanca: editingSale.status,
                    dataFechamento: editingSale.dataFechamento,
                });

                if (res.data.status) {
                    setNotificationType(1);
                    setEditingSale(null);
                    getFinancaVendedor(userCpf, rangeDateSells);
                } else {
                    setNotificationType(2);
                }
            } catch (err) {
                console.error('Erro ao salvar edição:', err);
                setNotificationType(3);
            }
        }
    };

    // ------------------- RENDERIZAÇÃO DE SERVIÇOS (BOLHAS) -------------------
    const getServiceNameByIndex = (index) => {
        const service = servicos.find(servico => servico.index === index);
        return service ? service.nome : 'Serviço desconhecido';
    };

    const renderBubbles = (servicosString) => {
        const parsedServices = JSON.parse(servicosString);
        return parsedServices.map((service, idx) => (
            <div key={idx} className={styles.bubble}>
                <p className={styles.bubbleText}>
                    ({service.quantidade}) {getServiceNameByIndex(service.index)}
                </p>
            </div>
        ));
    };

    const renderizarConteudo = (item) => {
        const quantidade = servicosJSONaux[item.index] || 0;
        const jaClicado = botoesClicados[item.nome];

        if (jaClicado && quantidade > 0) {
            // Layout quando item já foi clicado e quantidade > 0
            return (
                <div className={styles.servicosAgilClic} id={item.nome} key={item.nome}>
                    <p>{item.nome}</p>
                    <div className={styles.servicosAgilClicDiv}>
                        <button
                            className={styles.buttonQuadrado}
                            onClick={() => handleAtualizarValor(item.index, quantidade - 1)}
                        >
                            -
                        </button>
                        <p style={{fontSize: "1rem"}}>{quantidade}</p>
                        <button
                            className={styles.buttonQuadrado}
                            onClick={() => handleAtualizarValor(item.index, quantidade + 1)}
                        >
                            +
                        </button>
                    </div>
                </div>
            );
        } else if (jaClicado && quantidade <= 0) {
            // Se a quantidade foi zerada, volta para layout 'normal'
            return (
                <div
                    className={styles.servicosAgil}
                    id={item.nome}
                    key={item.nome}
                    onClick={() => handleButtonClick(item)}
                >
                    {item.nome}
                    <div>({item.value} R$)</div>
                </div>
            );
        } else {
            // Layout quando item não foi clicado ainda
            return (
                <div
                    className={styles.servicosAgil}
                    id={item.nome}
                    key={item.nome}
                    onClick={() => handleButtonClick(item)}
                >
                    {item.nome}
                    <div>({item.value} R$)</div>
                </div>
            );
        }
    };

    function FormattedDate({ date }) {
        const formattedDate = format(new Date(date), 'dd/MM/yyyy');
        return <p>{formattedDate}</p>;
    }

    // ------------------- RENDERIZAÇÃO PRINCIPAL -------------------
    return (
        <div className={styles.app}>
            <NotificationContainer />

            <div className={`${styles.corTitulo} ${styles.yellow}`}>
                <p className={styles.titulo}>Financeiro</p>
            </div>

            <div className={styles.cadastroClienteContainer}>
                <CreateCliente
                    clientesList={clientesList}
                    handleToggleShowAll={handleToggleShowAll}
                    showAllClientes={showAllClientes}
                    parceirosList={parceirosList}
                    onClienteSelecionado={handleClienteSelecionado}
                    onClienteCriado={handleClienteCriado}
                    errorCliente={clienteError}

                />
            </div>



            <div className={styles.cadastroClienteContainer}>
                                  <p className={styles.inputText} style={{ margin: 10 }}>---------------  VENDEDOR  ---------------</p>

                <div className={styles.containerVendedorInput}>
                    <div className={styles.containerVendedor}>
                        {/* <p className={styles.inputText}>VENDEDOR: </p> */}
                        
                        <select
                            onChange={(e) => setVendedor(e.target.value)}
                            value={vendedor}
                            className={styles.inputFilter}
                        >
                            <option value="">Selecione um Vendedor</option>
                            {vendedoresList.map((v) => (
                                <option key={v.id} value={v.cpf}>
                                    {v.nome} - {v.cpf}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className={styles.divisor}></div>
                    <div className={styles.divisor}></div>
                                  <p className={styles.inputText} style={{ margin: 10 }}>---------------  SERVIÇOS  ---------------</p>


                    {/* <p className={styles.inputText}>SERVIÇOS: </p> */}
                    <div className={styles.cadastroItems06}>
                        {servicos.map(item => renderizarConteudo(item))}
                    </div>

                    <div className={styles.containerTituloInput}>
                        <p className={styles.inputText}>VALOR PAGO: </p>
                        <input
                            className={styles.inputFilter}
                            type="number"
                            onChange={(e) => setValorPago(e.target.value)}
                            value={valorPago}
                            placeholder="valor pago"
                        />
                    </div>

                    <div className={styles.cadastroItems04}>
                        <div className={styles.itemContainer}>
                                  <p className={styles.inputText} style={{ margin: 10 }}>---------------  OBSERVAÇÕES  ---------------</p>
                            
                            <textarea
                                onChange={(e) => setObs(e.target.value)}
                                value={obs}
                                className={styles.textArea}
                                placeholder="Digite uma observação"
                            ></textarea>
                        </div>
                    </div>
                </div>

                <div>
                    <div className={styles.customFileInput}>
                        <input
                            id="fileInput"
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleFileChange}
                        />
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <label style={{ display: 'flex', alignItems: 'center' }} htmlFor="fileInput">
                                <div style={{ width: '20%' }}>
                                    <p>
                                        <FaCamera style={{ width: '30px', height: '30px', color: 'white' }} />
                                    </p>
                                </div>
                                <div style={{ width: '80%', paddingLeft: '10px' }}>
                                    {files.length === 0
                                        ? "Enviar comprovantes"
                                        : `${files.length} arquivo(s) selecionado(s)`}
                                </div>
                            </label>
                        </div>
                    </div>

                    <div className={styles.imagePreview}>
                        {files.map((file, index) => (
                            <div key={index} style={{ display: 'flex' }}>
                                <img
                                    src={URL.createObjectURL(file)}
                                    alt="preview"
                                    style={{ width: '100px', objectFit: 'cover', marginRight: '10px' }}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.buttonContainer}>
                    <button
                        onClick={() => {
                            setDataFechamento(getCurrentDate());
                            setStatusFinanca(0);
                            insertDataFinanca();
                        }}
                        className={styles.cadastroCliente}
                    >
                        GERAR NOTA
                    </button>
                </div>
            </div>

            {comprovanteEnviado === true && (
                <div
                    className={`${styles.cadastroClienteContainer} ${styles.copiar}`}
                    onClick={() => {
                        var r = document.createRange();
                        r.selectNode(document.getElementById('copiar'));
                        window.getSelection().removeAllRanges();
                        window.getSelection().addRange(r);
                        try {
                            document.execCommand('copy');
                            window.getSelection().removeAllRanges();
                            setNotificationType(19);
                        } catch (err) {
                            console.log('Unable to copy!');
                        }
                    }}
                >
                    <div className={styles.copiarTop}>COMPROVANTE (clica para copiar)</div>
                    <p id="copiar" className={styles.copiarText}>
                        Nome: {nomeClienteComprovante}
                        <br />
                        Contato: {contatoClienteComprovante}
                        <br />
                        CPF: {cpfClienteComprovante}
                        <br />
                        {parceiroClienteComprovante}
                        <br />
                        Valor: {valorComprovante}
                        <br />
                        Serviços: {servicosComprovante}
                        <br />
                        Obs: {obsComprovante}
                        <br />
                        {fonteLeadComprovante}
                    </p>
                </div>
            )}

            <div className={`${styles.corTitulo} ${styles.bluea}`}>
                <p className={styles.titulo}>Minhas vendas:</p>
            </div>
            <div className={styles.cadastroClienteContainer}>
                <div
                    className={styles.cadastroItems06}
                    style={{
                        borderRadius: "20px",
                        backgroundColor: "white",
                        overflow: "visible",
                        maxWidth: "600px",
                        paddingTop: "40px",
                    }}
                >
                    <GraficoVenda rawData={financaList} />
                    {/* <GraficoParceiros rawData={financaList} /> */}

                </div>

                {/* Select para escolher o intervalo de dias */}
                <div style={{ marginBottom: "20px" }}>
                    <label style={{ fontWeight: "bold", marginRight: "10px" }}>Selecionar período:</label>
                    <select
                        value={rangeDateSells}
                        onChange={(e) => setRangeDateSells(parseInt(e.target.value))}
                        style={{ padding: "5px", borderRadius: "5px", fontSize: "16px" }}
                    >
                        <option value={7}>Últimos 7 dias</option>
                        <option value={30}>Últimos 30 dias</option>
                        <option value={60}>Últimos 60 dias</option>
                    </select>
                </div>








                <div className={styles.usersListContainer}>
                    {financaList.map((user) => (
                        <div key={user.id} className={styles.userContainer} style={{ backgroundColor: 'var(--corPrimaria)', color: 'white' }}>
                            <div>
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <div style={{ width: '50%' }}>
                                        <p style={{ fontSize: '1rem', fontWeight: '600' }}>{user.clienteNome}</p>
                                    </div>
                                    <div style={{ width: '50%' }}>
                                        <p className={styles.loginContainer2} style={{ fontSize: '1rem', textAlign: 'end' }}>
                                            {user.valor}.00R$
                                        </p>
                                    </div>
                                </div>
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <div style={{ width: '50%' }}>
                                        <p>{user.clienteContato}</p>
                                    </div>
                                    <div style={{ width: '50%' }}>
                                        <p className={styles.loginContainer2} style={{ textAlign: 'end' }}>
                                            {user.vendedor} - {user.dataFechamento}
                                        </p>
                                    </div>
                                </div>
                                <div style={{ display: 'block', width: '100%' }}>
                                    <div className={styles.servicos}>
                                        {renderBubbles(user.servicos)}
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: '10px' }}>
                                <button
                                    className={styles.editButton}
                                    onClick={() => handleEdit(user)}
                                >
                                    Editar
                                </button>
                            </div>
                        </div>
                    ))}

                </div>




            </div>

            <div className={styles.rodape}></div>

            {editingSale && (
                <div className={styles.modal2}>
                    <div className={styles.modalContent2}>
                        <h3>Editar Venda</h3>
                        <label>Valor:</label>
                        <div>
                            <input
                                type="number"
                                value={editingSale.valor}
                                onChange={(e) => setEditingSale({ ...editingSale, valor: e.target.value })}
                            />
                        </div>
                        <label>Observações:</label>
                        <div>
                            <textarea
                                value={editingSale.obs}
                                onChange={(e) => setEditingSale({ ...editingSale, obs: e.target.value })}
                            />
                        </div>
                        <div className={styles.modalActions}>
                            <button onClick={() => setEditingSale(null)}>Cancelar</button>
                            <button onClick={handleSaveEdit}>Salvar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Financeiro;
